import { t } from "i18next";
import { CorePropsInterfaces, DTOs } from "src/core/Models";
import GtDialog from "./GtDialog";
import { Button } from "@mui/material";

function GtSendNotificationDialog({
  engagementLetterSignee,
  onReminderSent,
  onDialogClose,
}: CorePropsInterfaces.GtSendNotificationDialogProps): JSX.Element {
  const sendNotificationDialogDTO: DTOs.GtDialogDTO = {
    data: {
      title: t("General.SendNotification"),
      maxWidth: "sm",
      leftButtons: [],
      rightButtons: [
        <Button
          onClick={onDialogClose}
          color="tertiary"
          variant="outlined"
          key="cancelBtn"
        >
          {t("General.Cancel")}
        </Button>,
        <Button
          color="tertiary"
          variant="contained"
          key="confirmBtn"
          onClick={() => {
            onReminderSent();
          }}
        >
          {t("General.Send")}
        </Button>,
      ],
    },
    api: {
      onClose: onDialogClose,
    },
    state: {
      isOpen: true,
      isFullWidth: true,
    },
  };

  return (
    <GtDialog gtDialogDTO={sendNotificationDialogDTO}>
      {t("General.SendNotificationMessage", {
        Name:
          (engagementLetterSignee.FirstName || "") +
          " " +
          (engagementLetterSignee.LastName || ""),
      })}
    </GtDialog>
  );
}

export default GtSendNotificationDialog;
